
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type GetCourse200SectionsItemLecturesItemPlatformSupport = typeof GetCourse200SectionsItemLecturesItemPlatformSupport[keyof typeof GetCourse200SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourse200SectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
